import * as React from "react";
const SvgFiRrSiteAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-site-alt_svg__a)">
      <path
        fill="#062147"
        d="M23.414 16.09s-8.734-3.97-8.765-3.98a1.99 1.99 0 0 0-2.062.479c-.544.544-.727 1.334-.442 2.151l3.944 8.675a1 1 0 0 0 .892.586H17c.378 0 .725-.214.895-.553l1.851-3.702 3.702-1.851a1 1 0 0 0-.033-1.805zm-4.861 2.016a1 1 0 0 0-.447.447l-1.064 2.128-3.044-6.676 6.681 3.038-2.125 1.062zm-5.641 3.854q-.258.023-.52.033c-.668-.661-2.41-2.518-3.624-4.992H9.5a1 1 0 1 0 0-2H7.97c-.291-.952-.47-1.96-.47-3s.18-2.047.472-3h8.057q.178.58.295 1.187a.999.999 0 1 0 1.964-.374 13 13 0 0 0-.183-.813h3.433a10 10 0 0 1 .419 3.911 1 1 0 0 0 1.992.18q.049-.539.049-1.09C24 5.383 18.617 0 12 0S0 5.383 0 12s5.383 12 11.999 12q.55 0 1.088-.049a1 1 0 0 0-.176-1.992zm-7.02-6.959H2.46A10 10 0 0 1 2 12a10 10 0 0 1 .46-3.001h3.432a12 12 0 0 0-.392 3c0 1.041.146 2.045.392 3zm2.881-8c1.021-2.077 2.415-3.724 3.229-4.588.815.863 2.209 2.507 3.23 4.588zm11.885 0H17.43c-.791-1.886-1.888-3.488-2.832-4.657a10.05 10.05 0 0 1 6.06 4.657M9.4 2.344C8.456 3.513 7.358 5.115 6.568 7H3.342A10.04 10.04 0 0 1 9.4 2.344M3.342 17h3.226c.79 1.886 1.888 3.487 2.832 4.656A10.05 10.05 0 0 1 3.342 17"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-site-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSiteAlt;
